import { BaseSubject } from '../BaseSubject.model';
import { PADDING_TOP, TABS, THS } from '../constant';
import { getContentWidth } from '@/utils/contentWidth';
let OBJECT_LINE_HEIGHT = 100; // 选择题一行的高度
const MARGIN_BOTTOM = 10;
const OBJECTIVE_COLUMN_ITEM = 24;
const $ = require('jquery');
const TH_HEIGHT = 40; //标题高度

/**
 * 客观题
 * **/

export class ObjectiveModel extends BaseSubject {
  /**
   * 题目列表
   */
  items: { no: number; score: any; tType: any; optionNum: any; partScore: any; value: any }[] = [];
  /**
   * 自定义编辑
   */
  types: number;
  /**
   * 选项数
   * */
  optionNum: number;
  /**
   * 题型字段
   * */
  tType: number;

  /**
   * 每组显示几个选项
   * */
  rowNum: number;
  /**
   * 是否竖排
   * */
  diffLayout: number;

  /**
   * html 片段存储
   * */
  htmlArray: any;

  /**
   * totalGroupRows 总group行数
   * */
  totalGroupRows: any;
  /**
   * rowHeightList 高度列表
   * */
  rowHeightList: any;

  /**
   * 列数
   * */
  columnCount: number;
  boxs: any[] = [];
  partScore: number;
  constructor(obj?: {
    types?: number; // 自定义编辑 1
    columnCount?: number;
    name?: string;
    start?: any;
    end?: any;
    score?: any;
    tType?: any;
    optionNum?: any;
    rowNum?: any;
    diffLayout?: number;
    th?: any;
    items?: any[];
    rowHeightList?: any[];
    htmlArray?: any[];
    partScore?: any;
    innerHTML?: string;
    totalScore?: number;
  }) {
    super(obj);
    obj = obj || {};
    this.types = 1; // 自定义编辑 排列方向
    this.type = 2; // 客观题标识
    this.tType = obj.tType || 1; // 选项类型
    this.rowNum = obj.rowNum || 5; // 一组显示几个题
    this.name = obj.name; // 默认名称
    this.rowHeightList = obj.rowHeightList || []; //每行高度
    this.optionNum = obj.optionNum || 4; // 默认4个选项数
    this.columnCount = obj.columnCount || 2; // 默认2个列宽
    this.diffLayout = obj.diffLayout || 0; // 是否竖排
    this.htmlArray = obj.htmlArray || []; // html 片段存储
    this.innerHTML = obj.innerHTML || ''; // 填充内容部分
    this.totalScore = obj.totalScore || 0;
    this.partScore = obj.partScore;
    this.score = obj.score || 2;
    // if (obj.items && obj.items.length) {
    //   // this.items = [];
    //   this.innerHTML = obj.innerHTML;
    //   this.totalScore += obj.score;
    //   for (let idx = obj.start; idx <= obj.end; idx++) {
    //     obj.items.push({
    //       no: idx,
    //       score: obj!.score,
    //       tType: obj!.tType,
    //       optionNum: obj!.optionNum,
    //       partScore: obj!.partScore,
    //       value: idx,
    //     });
    //   }
    //   // 根据题号小题去重
    //   // this.items = obj.items.filter(item => {
    //   //   let nos = this.items.map(v => v.no);
    //   //   return !nos.includes(item.no);
    //   // });
    //   this.items = obj.items;
    //   const hash: any = {};
    //   this.items = this.items.reduce((item: any, next: any) => {
    //     hash[next.no] ? '' : (hash[next.no] = true && item.push(next));
    //     return item;
    //   }, []); // 对象数组去重
    // } else {
    //   for (let idx = obj.start; idx <= obj.end; idx++) {
    //     this.items.push({
    //       no: idx,
    //       score: obj.score,
    //       tType: obj.tType,
    //       optionNum: obj.optionNum,
    //       partScore: obj.partScore,
    //       value: idx,
    //     });
    //     console.log('选择题分数计算', obj.score);
    //   }
    // }

    if (obj.items && obj.items.length) {
      this.items = obj.items;
    } else {
      this.innerHTML = obj.innerHTML;
      this.totalScore += Number(obj.score);
      for (let idx = obj.start; idx <= obj.end; idx++) {
        obj.items &&
          this.items.push({
            no: idx,
            score: obj!.score,
            tType: obj!.tType,
            optionNum: obj!.optionNum,
            partScore: obj!.partScore,
            value: idx,
          });
      }
    }

    // 根据题号小题去重
    // this.items = obj.items.filter(item => {
    //   let nos = this.items.map(v => v.no);
    //   return !nos.includes(item.no);
    // });
  }

  // 追加
  addItems(obj: any) {
    for (let idx = Number(obj.start); idx <= Number(obj.end); idx++) {
      obj.items &&
        this.items.push({
          no: idx,
          score: obj!.score,
          tType: obj!.tType,
          optionNum: obj!.optionNum,
          partScore: obj!.tType !== 2 ? obj!.partScore : obj!.partScore ? obj!.partScore : 0,
          value: idx,
        });
    }
    const hash: any = {};
    this.items = this.items.reduce((item: any, next: any) => {
      hash[next.no] ? '' : (hash[next.no] = true && item.push(next));
      return item;
    }, []); // 对象数组去重
    this.items.sort((a: any, b: any) => {
      return a.no - b.no;
    });
  }

  // 新建
  createItems(obj: any) {
    this.items = [];
    for (let idx = obj.start; idx <= obj.end; idx++) {
      obj.items &&
        this.items.push({
          no: idx,
          score: obj!.score,
          tType: obj!.tType,
          optionNum: obj!.optionNum,
          partScore: obj!.tType !== 2 ? obj!.partScore : obj!.partScore ? obj!.partScore : 0,
          value: idx,
        });
    }
    const hash: any = {};
    this.items = this.items.reduce((item: any, next: any) => {
      hash[next.no] ? '' : (hash[next.no] = true && item.push(next));
      return item;
    }, []); // 对象数组去重
    this.items.sort((a: any, b: any) => {
      return a.no - b.no;
    });
  }

  async render(options = { diffLayout: 0, rowNum: 5 }) {
    const items = this.items;
    this.computedScoreAndTH();
    const length = items.length; // items 数组长度
    const rowNum = this.rowNum; // 一组几个选项
    const tabs = TABS;
    const rows = Math.ceil(items.length / rowNum); // 计算可以生成多少组
    
    const htmlArray = [];
    const diffLayout = (this.diffLayout = options.diffLayout || this.diffLayout);
    let tType = this.tType;
    const contentWidth = getContentWidth()+29; // 容器宽度
    let groupWidthArray: Array<number> = []; // 定义每个group的宽度合集

    let itemGroupArray: Array<string> = []; // 定义每大行所在的集合

    for (let index = 1; index <= rows; index++) {
      // 循环整个组的个数
      let startIdx = rowNum * (index - 1); // 循环每个组的数据时计算需要循环的items的开始下标
      let len = index === rows ? length - rowNum * (index - 1) : rowNum; // 循环items里面终止长度
      let rowArray = [];
      for (let idx = startIdx; idx < len + startIdx; idx++) {
        const item = items[idx]; // 当前遍历的对象
        if (!item) break;
        tType = item.tType;
        const optionNum = item.optionNum || 2;
        const html = await createHtmlString(item, diffLayout, tType);
        rowArray.push(html);
      }
      const groupWidth: any = await getGroupWidth(rowArray); // 获取每个 obj-group的宽度，进行累加计算
      console.log('看看宽度',groupWidth,index,rowArray,'groupWidthArray',groupWidthArray);
      const testTotalWidth = (eval(groupWidthArray.join('+')) || 0) + groupWidth;
      console.log('集合宽度',testTotalWidth,contentWidth);
      
      if (testTotalWidth > contentWidth) {
        // 如果集合宽度总合大于容器宽度，清空宽度集合，用于重新计算
        htmlArray.push(`<div class="object-item">${itemGroupArray.join('')}</div>`); // 每一大行的代码
        groupWidthArray = [groupWidth];
        itemGroupArray = [`<div class="obj-group">${rowArray.join('')}</div>`];
      } else {
        groupWidthArray.push(groupWidth);
        itemGroupArray.push(`<div class="obj-group">${rowArray.join('')}</div>`);
      }

      if (index === rows) {
        htmlArray.push(`<div class="object-item">${itemGroupArray.join('')}</div>`); // 每一大行的代码
      }
    }

    this.htmlArray = htmlArray;
    this.totalGroupRows = htmlArray.length;
    const innerHTML = htmlArray.join('');
    this.innerHTML = innerHTML;
    console.log(this, '选择题');
  }
  computedScoreAndTH(unComputedTH?: boolean) {
    this.totalScore = 0;
    this.items.forEach(item => {
      this.totalScore! += Number(item.score);
    });
    if (unComputedTH) {
      return;
    }
    if (this.items.length > 1) {
      this.start = this.items[0]&& this.items[0].no;
      this.end = this.items[this.items.length - 1].no;
    } else {
      this.start = this.items[0]&& this.items[0].no;
      this.end = this.items[0]&& this.items[0].no;
    }
  }
  deleteItem(index: number) {
    this.items.splice(index, 1);
    this.computedScoreAndTH(true);
  }

  appendToPage(state: any, pageHeight: number, newTopicHeight: number): void {
    let myNewTopicHeight = 12; // 客观题距离底部有一个padding-bottom10px的距离 + 2px的边框
    OBJECT_LINE_HEIGHT = (this.rowHeightList[0]-10) || 100;
    this.rowHeightList.forEach(((height:number) => {
      myNewTopicHeight+= (height-10);
    }));
    let totalGroupRowsHeight = myNewTopicHeight;
    state.newTopicHeight = myNewTopicHeight; //这里因为客观题底部加了padding 15px
    let currentPage = state.pageCell.length - 1;
    if (this.page.isSurplusPage(state, currentPage, TH_HEIGHT + OBJECT_LINE_HEIGHT+MARGIN_BOTTOM)) {
      state.pageCell[state.pageCell.length - 1].fillTopiclist.push({
        ...this,
        hasTitle: true,
        initDragHeight: totalGroupRowsHeight,
        innerHTML: this.innerHTML,
      });
      this.afterAppendToPage(state, state.newTopicHeight, currentPage, state.existHeight);
    } else {
      this.page.createNextPage(state.pageCell);
      currentPage++;
      this.page.insertNextPageHeadStack(
        state.pageCell[currentPage],
        state.newTopicHeight,
        this.type,
        this.innerHTML,
        { ...this, hasTitle: true }
      );
      this.afterAppendToPage(state, state.newTopicHeight, currentPage, 0);
    }
    // throw new Error('Method not implemented.');
  }

  afterAppendToPage(state: any, newTopicHeight: number, currentPage: number, existHeight: number,rowList?: any) {
    // 这里不选择遍历因为客观题最多分解一次。
    const currentTopicStack =
      state.pageCell[currentPage].fillTopiclist[
        state.pageCell[currentPage].fillTopiclist.length - 1
      ];
    const currentMaxHeight = state.pageCell[currentPage].contentHeight;
    const canFillHeight = currentMaxHeight - existHeight; // 可填充高度
    // const canFillHeight = this.page.getPageSurplus(state, currentPage);
    let topicHeight = newTopicHeight;
    let myrowHeightList = [];
    if (topicHeight > canFillHeight - TH_HEIGHT) {
      // 可填充的高度不足以填满题型的高度
      if (canFillHeight < TH_HEIGHT + OBJECT_LINE_HEIGHT) {
        newTopicHeight = topicHeight;
        this.addNextPage(state, currentPage, newTopicHeight, this.innerHTML, true);
      } else {
        topicHeight -= canFillHeight; //这里因为是客观题高度相减法需要注意 当剩余高度不足以一行100px的时候其实减去的也是整个OBJECT_LINE_HEIGHTpx 所以剩下的高度会有所误差
        newTopicHeight = topicHeight;
        console.log('totalGroudasdd规划好pRowsHeight',canFillHeight);
        let { bottomHTML, resolveHeight,rowHeightList } = this.resolveObjectiveHTML(
          this.innerHTML,
          canFillHeight - (rowList ? 0 : TH_HEIGHT),
          currentTopicStack,
          rowList
        );
        myrowHeightList = rowHeightList || []; //把splice拆解后的myrowHeightList递归到下一页
        this.innerHTML = bottomHTML;
        console.log('canFil222lHeight',newTopicHeight,canFillHeight,resolveHeight);
        newTopicHeight = newTopicHeight + canFillHeight - resolveHeight;
      }
      if(this.innerHTML) {
        this.page.createNextPage(state.pageCell);
        currentPage++;
        this.page.insertNextPageHeadStack(
          state.pageCell[currentPage],
          newTopicHeight,
          this.type,
          this.innerHTML,
          this
        );
        console.log('哈哈哈',this);
        this.afterAppendToPage(state, newTopicHeight, currentPage, 0,myrowHeightList);
      }
    } else {
      //PADDING_TOP+5 是选择题底部的padding值
      currentTopicStack.initDragHeight = newTopicHeight + (rowList ? (PADDING_TOP+2) : 0); //直接将剩余的高度复制给最后
      // currentTopicStack.initDragHeight = parseInt(String((newTopicHeight + PADDING_TOP+5)/OBJECT_LINE_HEIGHT))*OBJECT_LINE_HEIGHT; //直接将剩余的高度复制给最后
      currentTopicStack.isHurdle = false;
      rowList && (currentTopicStack.hasTitle = false);
      currentTopicStack.innerHTML = this.innerHTML;
      currentTopicStack.rowHeightList = rowList||[];
      console.log('客观题装载完毕', state.pageCell);
      return console.log('停止递归', currentPage, topicHeight, canFillHeight);
    }
  }

  resolveObjectiveHTML(innerHTML: string, canFillHeight: number, currentTopicStack: any,rowHeightList:any): any {
    const copyCanFillHeight = canFillHeight;
    const OBJECT_HTML_PRE = '<div class="object-item">';
    try {
      let ptags = innerHTML.split(OBJECT_HTML_PRE);
      ptags.shift();
      ptags = ptags.map((ptag: any) => {
        return OBJECT_HTML_PRE + ptag;
      });
      let dragPTags = 0; 
      let resolveHeight = 0;
      console.log('客观题分解题型解析','canFillHeight',canFillHeight,rowHeightList);
      (rowHeightList || this.rowHeightList).forEach((height: number,index:number) => {
        if(canFillHeight > (height-10) + MARGIN_BOTTOM) {
          dragPTags = index+1;
          resolveHeight += (height-10);
        }
        canFillHeight -= (height-10);
      })
      let myrowHeightList = rowHeightList || JSON.parse(JSON.stringify(this.rowHeightList));
      //  dragPTags = parseInt(String(canFillHeight / OBJECT_LINE_HEIGHT)); //取整 会遇到特殊情况 正好是OBJECT_LINE_HEIGHT的整数 这边是要考虑标题的高度
      //  resolveHeight = dragPTags * OBJECT_LINE_HEIGHT;
      const hurdleTags = ptags && ptags.splice(0, dragPTags);
      currentTopicStack.innerHTML = hurdleTags.join('');
      currentTopicStack.isResolved = true; //设置当前分解stack题型是否是分解
      currentTopicStack.isHurdle = true;
      currentTopicStack.initDragHeight = (resolveHeight) || 50;
      currentTopicStack.rowHeightList = myrowHeightList.splice(0,dragPTags);
      // console.log('客观题分解题型解析',currentTopicStack.rowHeightList,myrowHeightList,'dragPTags',dragPTags,'rowHeightList',this.rowHeightList,'resolveHeight',resolveHeight);
      return { bottomHTML: ptags.join(''), resolveHeight: resolveHeight, rowHeightList:myrowHeightList };
    } catch (e) {
      console.error('客观题分解报错', e.message);
    }
  }

  addNextPage(
    state: any,
    currentPage: number,
    topicHeight: number,
    innerHTML?: string,
    hasTitle?: boolean
  ): void {
    this.page.createNextPage(state.pageCell);
    currentPage++;
    this.page.insertNextPageHeadStack(
      state.pageCell[currentPage],
      topicHeight,
      this.type,
      innerHTML,
      { ...this, hasTitle: hasTitle }
    );
    console.log('选择提', state.pageCell[currentPage], this);
  }
}

function getGroupWidth(rowArray: any) {
  return new Promise((resolve, reject) => {
    let groupWidth = $('#test-obj-group')
      .html(rowArray)
      .width();
    console.log('看看客观题每题的宽度',groupWidth);
    groupWidth = parseInt(String(groupWidth/OBJECTIVE_COLUMN_ITEM))*OBJECTIVE_COLUMN_ITEM; // 这里因为 5个选项一组的话每组的宽度是120正好是5*24 一列是24宽度
    resolve(groupWidth+20); // 加上内边距宽度一起返回
    // resolve(groupWidth+10); // 加上内边距宽度一起返回
  });
}

function createHtmlString(item?: any, diffLayout?: any, tType?: any) {
  return new Promise((resolve, reject) => {
    let html = '';
    const judgeOption = ['T', 'F'];
    if (tType === 3) {
      for (let i = 0; i <= judgeOption.length; i++) {
        const slotContent = i === 0 ? `${item.no}` : `[${judgeOption[i - 1]}]`;
        html += `<span class="gro-item" style="display: ${
          diffLayout ? 'block' : 'inline-block'
        }">${slotContent}</span>`;
      }
    } else {
      for (let i = 0; i <= item.optionNum; i++) {
        const option = TABS[i - 1];
        const slotContent = i === 0 ? `${item.no}` : `[${option}]`; // 查找选项值的位置
        html += `<span class="gro-item" style="display: ${
          diffLayout ? 'block' : 'inline-block'
        }">${slotContent}</span>`;
      }
    }
    resolve(
      `<div class="group"  style="display: ${diffLayout ? 'inline-block' : 'block'}">${html}</div>`
    );
  });
}
